import Axios from 'axios';
import header from './auth/header';

const API_URL_V3 = process.env.API_URL + '/api/v3/'

class DepositoProduct {
  index(params) {
    let url = new URLSearchParams(params).toString();
    return Axios.get(`${API_URL_V3}product/funder?search_category=Deposito&${url}`);
  }
  
}

export default new DepositoProduct();



// WEBPACK FOOTER //
// ./src/api/depositoProduct.js